var _defs, _g, _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInspirationByte(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Inspiration_Byte",
    "data-name": "Inspiration Byte",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_949",
    "data-name": "Rectangle 949",
    width: 24,
    height: 24,
    transform: "translate(-7758 7246)",
    fill: "#fff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon_InspirationByte",
    "data-name": "Icon/InspirationByte",
    transform: "translate(7758 -7246)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_892",
    "data-name": "Group 892",
    transform: "translate(-7757.553 7247.279)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_946",
    "data-name": "Rectangle 946",
    width: 0.857,
    height: 1.286,
    transform: "matrix(1, -0.017, 0.017, 1, 6.013, 0.015)",
    fill: "#bcbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_947",
    "data-name": "Rectangle 947",
    width: 0.9,
    height: 1.286,
    transform: "matrix(0.999, 0.035, -0.035, 0.999, 13.097, 20.383)",
    fill: "#bcbbbc"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_948",
    "data-name": "Rectangle 948",
    width: 0.857,
    height: 10.953,
    transform: "translate(7.223 2.55) rotate(-16)",
    fill: "#bcbbbc"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_796",
    "data-name": "Path 796",
    transform: "translate(15.456 10.888)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.484-2.542V-.228l2.878.2,5.375,4.3L-5.618,3.56-3.21.644V-1.748Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -2.210384368896484 0.7928978800773621 L -2.210384368896484 1.003693699836731 L -3.598020315170288 2.684154033660889 L 2.675606727600098 3.075592994689941 L 0.01333101093769073 0.9442608952522278 L -2.210384368896484 0.7928978800773621 M -2.483814477920532 -2.542476177215576 L -2.483814477920532 -0.228026270866394 L 0.3937655985355377 -0.03215634822845459 L 5.768275737762451 4.270503997802734 L -5.618164539337158 3.560053825378418 L -3.210384368896484 0.6441836357116699 L -3.210384368896484 -1.748116254806519 L -2.483814477920532 -2.542476177215576 Z",
    stroke: "none",
    fill: "#bcbbbc"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_797",
    "data-name": "Path 797",
    transform: "translate(14.763 10.888)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-2.484-2.542V-.228l2.878.2,5.375,4.3L-5.618,3.56-3.21.644V-1.748Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M -2.210384368896484 0.7928978800773621 L -2.210384368896484 1.003693699836731 L -3.598020315170288 2.684154033660889 L 2.675606727600098 3.075592994689941 L 0.01333101093769073 0.9442608952522278 L -2.210384368896484 0.7928978800773621 M -2.483814477920532 -2.542476177215576 L -2.483814477920532 -0.228026270866394 L 0.3937655985355377 -0.03215634822845459 L 5.768275737762451 4.270503997802734 L -5.618164539337158 3.560053825378418 L -3.210384368896484 0.6441836357116699 L -3.210384368896484 -1.748116254806519 L -2.483814477920532 -2.542476177215576 Z",
    stroke: "none",
    fill: "#f6f6f6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_798",
    "data-name": "Path 798",
    transform: "translate(2.813 0.971)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,10.26,4.055-.937,5.2.79l.8.973.253.308,3.667,5.2,3.72-1.938V9.869l6.428,4.624L11.4,15.643,11.1,20.722,8.031,16.811.309,20.143,4.055,12.8-1.956,10.26Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.460034370422363 18.1259765625 L 8.342934608459473 15.58790397644043 L 10.25740718841553 18.02976226806641 L 10.45396423339844 14.76026344299316 L 17.43773078918457 13.83291721343994 L 12.63909435272217 10.38117408752441 L 12.63909435272217 6.978621482849121 L 9.605884552001953 8.559113502502441 L 5.455635547637939 2.677009344100952 L 5.124619960784912 2.273812294006348 L 5.319254398345947 11.26018333435059 L 2.983212471008301 11.26018333435059 L 5.434004306793213 12.29497337341309 L 2.460034370422363 18.1259765625 M 11.09737491607666 20.72188377380371 L 8.031464576721191 16.8113842010498 L 0.3085944354534149 20.14327430725098 L 4.054824352264404 12.79813385009766 L -1.956055521965027 10.26018333435059 L 4.297364234924316 10.26018333435059 L 4.054824352264404 -0.9374961853027344 L 5.199914455413818 0.7895538210868835 L 6.251674652099609 2.070663690567017 L 9.919013977050781 7.268343925476074 L 13.63909435272217 5.329943656921387 L 13.63909435272217 9.868654251098633 L 20.0672435760498 14.49253368377686 L 11.40269470214844 15.64306354522705 L 11.09737491607666 20.72188377380371 Z",
    stroke: "none",
    fill: "#bcbbbc"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_799",
    "data-name": "Path 799",
    d: "M-4.322-1.39h.373L1.11,15.966l-2.55-3.23-4.955,2.233L-4.46,9.435-6.911,7.952h2.753Z",
    transform: "translate(11.216 4.23)",
    fill: "#f5bb68"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_110",
    "data-name": "Line 110",
    x1: 2.143,
    y2: 3,
    transform: "translate(5.338 15.65)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_111",
    "data-name": "Line 111",
    x2: 2.143,
    y2: 1.286,
    transform: "translate(8.767 14.793)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_112",
    "data-name": "Line 112",
    x2: 3.429,
    transform: "translate(4.053 12.221)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_113",
    "data-name": "Line 113",
    y2: 6,
    transform: "translate(7.053 6.65)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_114",
    "data-name": "Line 114",
    x2: 2.571,
    y2: 10.286,
    transform: "translate(7.053 2.793)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_115",
    "data-name": "Line 115",
    y2: 4.286,
    transform: "translate(7.481 8.364)",
    fill: "none",
    stroke: "#efb561",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path_800",
    "data-name": "Path 800",
    transform: "translate(1.956 0.971)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.3,10.26,4.055-.937,5.2.79l.8.973.253.308,3.667,5.2,3.72-1.938V9.869l6.428,4.624L11.4,15.643,11.1,20.722,8.031,16.811.309,20.143,4.055,12.8-1.956,10.26Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.460034370422363 18.1259765625 L 8.342934608459473 15.58790397644043 L 10.25740718841553 18.02976226806641 L 10.45396423339844 14.76026344299316 L 17.43773078918457 13.83291721343994 L 12.63909435272217 10.38117408752441 L 12.63909435272217 6.978621482849121 L 9.605884552001953 8.559113502502441 L 5.455635547637939 2.677009344100952 L 5.124619960784912 2.273812294006348 L 5.319254398345947 11.26018333435059 L 2.983212471008301 11.26018333435059 L 5.434004306793213 12.29497337341309 L 2.460034370422363 18.1259765625 M 11.09737491607666 20.72188377380371 L 8.031464576721191 16.8113842010498 L 0.3085944354534149 20.14327430725098 L 4.054824352264404 12.79813385009766 L -1.956055521965027 10.26018333435059 L 4.297364234924316 10.26018333435059 L 4.054824352264404 -0.9374961853027344 L 5.199914455413818 0.7895538210868835 L 6.251674652099609 2.070663690567017 L 9.919013977050781 7.268343925476074 L 13.63909435272217 5.329943656921387 L 13.63909435272217 9.868654251098633 L 20.0672435760498 14.49253368377686 L 11.40269470214844 15.64306354522705 L 11.09737491607666 20.72188377380371 Z",
    stroke: "none",
    fill: "#f6f6f6"
  }))))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_957",
    "data-name": "Rectangle 957",
    width: 24,
    height: 24,
    fill: "rgba(255,255,255,0)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInspirationByte);
export default __webpack_public_path__ + "static/media/InspirationByte.2e13cae8.svg";
export { ForwardRef as ReactComponent };